import { render, staticRenderFns } from "./CarPreview.vue?vue&type=template&id=70c395a1&scoped=true&"
import script from "./CarPreview.vue?vue&type=script&lang=js&"
export * from "./CarPreview.vue?vue&type=script&lang=js&"
import style0 from "./CarPreview.vue?vue&type=style&index=0&id=70c395a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c395a1",
  null
  
)

export default component.exports